module.exports = __webpack_public_path__ + "static/media/worknest-small.15f4a91c.svg";